import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../firebase';

export function useFeatureFlag(flagName: string): boolean {
  const [flagValue, setFlagValue] = useState<boolean>(false);

  useEffect(() => {
    // We must wait for auth to be mapped, but hooks can't easily await synchronously.
    // Instead we rely on auth.onAuthStateChanged
    let unsubscribeSnap: (() => void) | undefined;
    
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (user) {
        const userRef = doc(db, 'users', user.uid);
        unsubscribeSnap = onSnapshot(userRef, (snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.data();
            setFlagValue(!!data?.features?.[flagName]);
          } else {
            setFlagValue(false);
          }
        }, (error: any) => {
          if (error.code === 'permission-denied' && !auth.currentUser) {
            // Ignore benign logout race conditions
          } else {
            console.error("useFeatureFlag error", error);
          }
          setFlagValue(false);
        });
      } else {
        setFlagValue(false);
        if (unsubscribeSnap) unsubscribeSnap();
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubscribeSnap) unsubscribeSnap();
    };
  }, [flagName]);

  return flagValue;
}
